import type { FieldError } from 'react-hook-form'

export const ValidationError = ({ error }: { error?: FieldError }) => {
  if (!error) return null
  return (
    <p className="mt-1 text-left text-sm leading-compact text-ink-danger">
      {error.message}
    </p>
  )
}
